import React, { useState } from 'react';
import {
  Panel,
  theme,
  Text,
  Box,
  Button,
  Flex,
  Link,
} from '@xometry/xometry_loft';
import TeamsTable from './TeamsTable';
import InvitationModal from './invitationModal';
import { WWW_ORIGIN } from '../../config';

interface TeamProps {
  userId: string;
  isStaff: boolean;
  setPendingInvites: (invites: any[]) => void;
  contentView: string;
  invitationModalData: InviteModalData;
  setInvitationModalData: () => void;
}

export type InviteModalData = {
  inviterFirstName: string;
  inviterLastName: string;
  teamName: string;
  openStatus: boolean;
  url: string;
  isStaffActingOnBehalfOfUser: boolean;
  buttonDecision: string;
  userEmail: string;
  orgId: string;
  userName: string;
};

const Teams = ({
  userId,
  isStaff,
  setPendingInvites,
  contentView,
  invitationModalData,
  setInvitationModalData,
}: TeamProps) => {
  const [showCreateTeamButton, setShowCreateTeamButton] =
    useState<boolean>(false);

  return (
    <>
      <Box maxWidth="792px" width="100%">
        <Flex justifyContent="space-between" mb={theme.space[4]}>
          <Text kind="subpage-title">Teams</Text>
          {showCreateTeamButton && (
            <Link href={`${WWW_ORIGIN}/account/organization/create`}>
              <Button type="button" kind={theme.kind.primary}>
                Create a New Team
              </Button>
            </Link>
          )}
        </Flex>
        <Panel kind="primary" padding="0">
          <TeamsTable
            isStaff={isStaff}
            userId={userId}
            invitationModalData={invitationModalData}
            setInvitationModalData={setInvitationModalData}
            setShowCreateTeamButton={setShowCreateTeamButton}
            updatePendingInvitesInParent={setPendingInvites}
            contentView={contentView}
          />
        </Panel>
      </Box>
      <InvitationModal
        invitationModalData={invitationModalData}
        setInvitationModalData={setInvitationModalData}
      />
    </>
  );
};

export default Teams;
